import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import DialogActions from '@material-ui/core/DialogActions';

// Cor de destaque da campanha (searchColor) com fallback no theme.
// O roxo/azul/etc das campanhas vem do searchColor, NÃO do theme.palette.primary
// (esse é o tema fixo "padrao" = salmão). Sempre derivar daqui.
const accentOf = (theme, accent) => accent || theme.palette.primary.main;

export const Modal = styled.div`
	.enabled {
		color: green;
	}

	.disabled {
		color: red;
	}
`;

export const BlankCard = styled.div`
	${({ theme }) => css`
		height: auto;
		width: 100%;
		background: #ffffff 0% 0% no-repeat padding-box;
		box-shadow: 0px 1px 4px #15223214;
		border-radius: 6px;
		opacity: 1;
		padding: 12px;
		padding-top: 9px;
		margin-bottom: 40px;
	`}
`;

export const CreditCard = styled.div`
	${({ theme }) => css``}
`;
export const TitleWrapper = styled.div`
	${({ theme }) => css`
		width: 100vw;
		display: flex;
		justify-content: center;
		flex-direction: row;
	`}
`;

export const Title = styled.div`
	${({ theme }) => css`
		&.active {
			background-color: ${theme.palette.primary.main};
			color: ${theme.palette.secondary.white};
		}
		&.inactive {
			background-color: #ccc;
			color: ${theme.palette.secondary.white};
			cursor: pointer;
		}
		padding-top: 1.8vh;
		width: 100%;
		height: 7vh;
		text-align: center;
		font: normal normal bold 18px Poppins;
		letter-spacing: 0px;
		opacity: 1;
	`}
`;
export const CustomDialogActions = styled(DialogActions)`
	padding: 0 !important;
`;

export const ForgotPass = styled.button`
	${({ theme }) => css`
		background: none;
		color: #1166bb;
		border: none;
		padding: 0;
		font: inherit;
		cursor: pointer;
		outline: inherit;
	`}
`;

/* ------------------------------------------------------------------ */
/* Identificação - choice screen (Vale Viagem x Convidado)            */
/* Cores de marca derivam do theme/campanha (white-label).            */
/* Apenas cinzas neutros são fixos.                                   */
/* ------------------------------------------------------------------ */

export const Banner = styled.div`
	${({ theme, isVoucher, accent }) => {
		const c = accentOf(theme, accent);
		return css`
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 14px 20px;
		font: normal normal 600 14px Poppins;
		background-color: ${isVoucher ? rgba(c, 0.12) : '#EEF1F4'};
		color: ${isVoucher ? c : '#3a3a3a'};

		svg {
			color: ${isVoucher ? c : '#5a5a5a'};
			font-size: 22px;
			flex-shrink: 0;
		}

		.banner-text {
			flex: 1;
		}

		.banner-close {
			background: none;
			border: none;
			cursor: pointer;
			color: inherit;
			display: flex;
			padding: 0;
			opacity: 0.7;

			&:hover {
				opacity: 1;
			}
		}
	`;
	}}
`;

export const Body = styled.div`
	padding: 28px 28px 32px;
`;

export const Heading = styled.h2`
	margin: 0 0 8px;
	font: normal normal bold 26px Poppins;
	color: #2b2b2b;
`;

export const Subheading = styled.p`
	margin: 0 0 22px;
	font: normal normal normal 16px Poppins;
	color: #5a5a5a;
`;

export const PointsInfo = styled.div`
	${({ theme, accent }) => css`
		display: flex;
		gap: 12px;
		background-color: #f5f6f7;
		border-left: 4px solid ${accentOf(theme, accent)};
		border-radius: 6px;
		padding: 14px 16px;
		margin-bottom: 24px;
		font: normal normal normal 14px Poppins;
		color: #3a3a3a;
		line-height: 1.45;

		b {
			color: ${accentOf(theme, accent)};
		}
	`}
`;

export const ChoiceGrid = styled.div`
	display: flex;
	gap: 18px;

	@media (max-width: 600px) {
		flex-direction: column;
	}
`;

export const ChoiceCard = styled.div`
	${({ theme, variant, accent }) => {
		const c = accentOf(theme, accent);
		return css`
		flex: 1;
		display: flex;
		flex-direction: column;
		border: 1px solid #e6e6e6;
		border-radius: 12px;
		padding: 20px;
		transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;

		&:hover {
			border-color: ${c};
			box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
			transform: translateY(-2px);
		}

		.card-icon {
			width: 44px;
			height: 44px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 16px;
			background-color: ${variant === 'brand' ? rgba(c, 0.12) : '#EEF1F4'};
			color: ${variant === 'brand' ? c : '#5a5a5a'};
		}

		.card-title {
			font: normal normal bold 18px Poppins;
			color: #2b2b2b;
			margin: 0 0 8px;
		}

		.card-desc {
			font: normal normal normal 14px Poppins;
			color: #6a6a6a;
			line-height: 1.45;
			margin: 0 0 20px;
			flex: 1;
		}
	`;
	}}
`;

export const BackLink = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	background: none;
	border: none;
	padding: 0;
	margin-bottom: 16px;
	cursor: pointer;
	color: #1166bb;
	font: normal normal 600 14px Poppins;

	svg {
		font-size: 18px;
	}
`;

/* Botão primário (preenchido) e secundário (contornado) derivados da cor da
   campanha (searchColor) com fallback para o theme. Não usam o ThemeButton
   para evitar o bug do `close` (fundo e texto na mesma cor). */

export const PrimaryButton = styled.button`
	${({ theme, accent }) => css`
		width: 100%;
		height: 52px;
		border: none;
		border-radius: 6px;
		cursor: pointer;
		font: normal normal 600 15px Poppins;
		background-color: ${accentOf(theme, accent)};
		color: #ffffff;
		transition: opacity 0.15s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;

		svg {
			font-size: 20px;
		}

		&:hover {
			opacity: 0.9;
		}
	`}
`;

export const SecondaryButton = styled.button`
	${({ theme, accent }) => css`
		width: 100%;
		height: 52px;
		border-radius: 6px;
		cursor: pointer;
		font: normal normal 600 15px Poppins;
		background-color: #ffffff;
		border: 1px solid ${accentOf(theme, accent)};
		color: ${accentOf(theme, accent)};
		transition: opacity 0.15s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;

		svg {
			font-size: 20px;
		}

		&:hover {
			opacity: 0.85;
		}
	`}
`;

/* ------------------------------------------------------------------ */
/* Formulários (login / cadastro) - layout do Figma                   */
/* ------------------------------------------------------------------ */

export const FormSection = styled.div`
	position: relative;
	padding: 16px 28px 22px;
	overflow-x: hidden;
	box-sizing: border-box;

	* {
		box-sizing: border-box;
	}
`;

export const FormTopBar = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
`;

export const BackButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	color: #6a6a6a;
	font: normal normal 600 14px Poppins;

	&:hover {
		color: #2b2b2b;
	}

	svg {
		font-size: 18px;
	}
`;

export const CloseButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	color: #6a6a6a;
	display: flex;
	padding: 4px;
	line-height: 0;

	&:hover {
		color: #2b2b2b;
	}

	svg {
		font-size: 22px;
	}
`;

export const FormHeading = styled.h2`
	${({ theme, brand, center, accent }) => css`
		margin: 0 0 6px;
		font: normal normal bold 26px Poppins;
		color: ${brand ? accentOf(theme, accent) : '#2b2b2b'};
		text-align: ${center ? 'center' : 'left'};
	`}
`;

export const FormSubtitle = styled.p`
	${({ center }) => css`
		margin: 0 0 18px;
		font: normal normal normal 15px Poppins;
		color: #5a5a5a;
		line-height: 1.45;
		text-align: ${center ? 'center' : 'left'};
	`}
`;

export const Field = styled.div`
	margin-bottom: 13px;
`;

export const FieldLabel = styled.label`
	display: block;
	margin-bottom: 6px;
	font: normal normal 600 13px Poppins;
	color: #3a3a3a;
`;

export const FieldRow = styled.div`
	display: flex;
	gap: 14px;

	> div {
		flex: 1 1 0;
		min-width: 0;
	}

	@media (max-width: 600px) {
		flex-direction: column;
		gap: 0;
	}
`;

export const InputBox = styled.div`
	${({ theme, accent }) => css`
		display: flex;
		align-items: center;
		gap: 8px;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		padding: 0 12px;
		height: 46px;
		background: #ffffff;
		box-shadow: 0px 4px 16px #455b6314;
		transition: border-color 0.15s ease;

		&:focus-within {
			border-color: ${accentOf(theme, accent)};
		}

		> svg {
			color: #9aa3ad;
			font-size: 20px;
			flex-shrink: 0;
		}

		input {
			flex: 1;
			min-width: 0;
			border: none;
			outline: none;
			background: transparent;
			font: normal normal normal 15px Poppins;
			color: #2b2b2b;
			height: 100%;

			&::placeholder {
				color: #aab2bb;
			}
		}

		.toggle {
			background: none;
			border: none;
			cursor: pointer;
			padding: 0;
			display: flex;
			color: #9aa3ad;
		}
	`}
`;

export const ForgotLink = styled.button`
	${({ theme, accent }) => css`
		display: block;
		margin: 2px 0 0 auto;
		background: none;
		border: none;
		padding: 0;
		cursor: pointer;
		font: normal normal 600 13px Poppins;
		color: ${accentOf(theme, accent)};
	`}
`;

export const OrDivider = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin: 22px 0;
	color: #9aa3ad;
	font: normal normal normal 13px Poppins;

	&::before,
	&::after {
		content: '';
		flex: 1;
		height: 1px;
		background: #e6e6e6;
	}
`;

export const Terms = styled.p`
	${({ theme, accent }) => css`
		margin: 18px 0 0;
		font: normal normal normal 12px Poppins;
		color: #8a8a8a;
		text-align: center;
		line-height: 1.5;

		.link {
			color: ${accentOf(theme, accent)};
			cursor: pointer;
		}
	`}
`;

export const SwitchLink = styled.p`
	${({ theme, accent }) => css`
		margin: 16px 0 0;
		text-align: center;
		font: normal normal normal 14px Poppins;
		color: #5a5a5a;

		.link {
			color: ${accentOf(theme, accent)};
			font-weight: 600;
			cursor: pointer;
		}
	`}
`;

export const ErrorText = styled.p`
	margin: 12px 0 0;
	font: normal normal normal 13px Poppins;
	color: #d64531;
	text-align: center;
`;
